export default __webpack_public_path__ + "static/media/dt4.7f90ba73.jpg";